import {Utilities} from '@shared/utilities/utilities.model';

export class NotificationModel {
	id?: string;
	action: string;
	created_at: string;
	is_read: boolean;
	metadata: any;
	module: NotificationModuleKeys[];
	modules?: NotificationModuleKeys[];
	notification_id: string;
	priority: NotificationPriority;
	read_date: string;
	reference_id: string;
	reference_type: string;
	text: string;
	title: string;
	type: NotificationType;
	user_id: string;
	start_date: Date | string;
	end_date: Date | string;
	stats?: { sent_to: number; read_by: number }; //per la chip con le stats
	loader?: boolean; //per la chip con le stats
	username?: string;
	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			Object.assign(this, model);
		}
	}
}

export enum NotificationType {
	DEFAULT = 'DEFAULT',
	BROADCAST = 'BROADCAST',
	BREAKING_NEWS = 'BREAKING_NEWS',
}

export enum NotificationPublishType {
	POSTED = 'POSTED',
	TO_POST = 'TO_POST',
}

export enum NotificationPriority {
	NORMAL = 'NORMAL',
	HIGH = 'HIGH',
	HIGHEST = 'HIGHEST',
}

export enum NotificationModuleKeys {
	AUTHORITY = 'authority',
	CLAIMS = 'claims',
	CONTRACT_CLOSING = 'contract-closing',
	TYRES = 'tyres',
	USER_CHANGE_ = 'change-user',
	LOGISTICS = 'logistics',
	FLOTTA_POOL = 'flotta-pool',
	INVOICING = 'invoicing',
	DELIVERY = 'delivery',
	BOOKINGS_RELIEF = 'bookings-relief',
	BOOKINGS_PRELEASE = 'bookings-prelease',
	// TODO add all the other modules keys
}
